import { render } from "./more.vue?vue&type=template&id=28885ac5"
import script from "./more.vue?vue&type=script&lang=js"
export * from "./more.vue?vue&type=script&lang=js"

import "./more.vue?vue&type=style&index=0&id=28885ac5&lang=css"

import exportComponent from "/var/jenkins_home/uat/ydd-zht-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__